// src/pages/NotFound.jsx
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const NotFound = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div style={styles.outerWrap}>
      <div style={styles.card}>
        <div style={styles.code}>404</div>
        <h1 style={styles.title}>{t("not_found") || "Page not found"}</h1>
        <p style={styles.text}>
          The page you’re looking for doesn’t exist, was moved, or the link is broken.
        </p>

        <div style={styles.actions}>
          <button
            type="button"
            onClick={() => navigate(-1)}
            style={styles.buttonPrimary}
          >
            ⬅︎ Go Back
          </button>

          <Link to="/" style={styles.buttonLinkReset}>
            <button type="button" style={styles.buttonPrimary}>
              ⌂ Back to Home
            </button>
          </Link>
        </div>

        {/* Decorative icon at the bottom */}
        <div style={styles.iconWrap} aria-hidden="true">
          {/* A simple “compass/map” style inline SVG */}
          <svg
            width="88"
            height="88"
            viewBox="0 0 24 24"
            fill="none"
            role="img"
            aria-label="Lost"
          >
            <path d="M12 2a10 10 0 100 20 10 10 0 000-20Z" stroke="#1E2A78" strokeWidth="1.5"/>
            <path d="M8.2 15.8l2.7-6.7 6.7-2.7-2.7 6.7-6.7 2.7Z" fill="#1E2A78" opacity="0.12"/>
            <path d="M8.2 15.8l2.7-6.7 6.7-2.7-2.7 6.7-6.7 2.7Z" stroke="#1E2A78" strokeWidth="1.25" />
            <circle cx="12" cy="12" r="1.25" fill="#1E2A78" />
          </svg>
        </div>
      </div>
    </div>
  );
};

const styles = {
  // ✅ Matches FileVaultPage: same width & top margin
  outerWrap: {
    maxWidth: 960,
    margin: "24px auto",
    padding: "0 16px 40px",
  },

  card: {
    padding: 28,
    background: "#fff",
    border: "1px solid #e5e7eb",
    borderRadius: 12,
    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
    textAlign: "center",
  },

  code: {
    fontSize: 88,
    fontWeight: 900,
    lineHeight: 1,
    color: "#111827",
    letterSpacing: "-1px",
  },

  title: {
    marginTop: 8,
    fontSize: 24,
    fontWeight: 800,
    color: "#111827",
  },

  text: {
    marginTop: 8,
    fontSize: 14,
    color: "#6b7280",
  },

  actions: {
    display: "flex",
    gap: 12,
    justifyContent: "center",
    alignItems: "center",
    marginTop: 18,
    flexWrap: "wrap",
  },

  // Brand primary button (same as Send button color)
  buttonPrimary: {
    padding: "10px 16px",
    fontSize: 16,
    backgroundColor: "#1E2A78",
    color: "#fff",
    border: "none",
    borderRadius: 10,
    cursor: "pointer",
    fontWeight: 800,
    boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
  },

  // Remove link styling around the button
  buttonLinkReset: { textDecoration: "none" },

  iconWrap: {
    marginTop: 20,
    display: "flex",
    justifyContent: "center",
  },
};

export default NotFound;
